<script>
  import { onMount, onDestroy } from "svelte";
  import toasts from "$lib/UI/toast-store";

  let timer = undefined;

  onMount(() => {
    timer = setInterval(tickTock, 1000);
  });

  onDestroy(() => {
    if (timer !== undefined) {
      clearInterval(timer);
    }
  });

  function tickTock() {
    $toasts.forEach((t) => {
      if (t.delay > 0) {
        t.delay -= 1;
      }
    });
    toasts.clean();
  }
</script>

<div class="toast-container">
  {#each $toasts as toast (toast.id)}
    <div class="toast">{toast.label}</div>
  {/each}
</div>

<style>
  .toast-container {
    position: fixed;
    bottom: 5vh;
    left: calc(50vw - 125px);
    width: 250px;
    background: transparent;
    z-index: 100;
  }

  .toast {
    color: var(--toast-color, white);
    border: solid 1px rgba(66, 66, 66, 0.9);
    border-color: var(--toast-background, rgba(66, 66, 66, 0.9));
    background: var(--toast-background, rgba(66, 66, 66, 0.9));
    margin: 1rem;
    padding: 0.5rem;
    min-height: 50px;
    border-radius: 5px;
    animation: append-animate .3s linear;
  }

  @keyframes append-animate {
	from {
		transform: scale(0);
		opacity: 0;
	}
	to {
		transform: scale(1);
		opacity: 1;	
	}
}
</style>
